import React from 'react'
import store from '../store/store'

export default function Results() {
    const foundCards = store((state) => state.recipes.length)
    const searchValue = store((state) => state.searchValue)

  return (
    <div>
        { searchValue.length >= 3 ?
            <p id='result_infos' >Results: We found <span>{foundCards}</span> recipes for you based on the keyword: <span>'{searchValue}'</span></p>
            :
            null
        }
    </div>
  )
}
